/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable  camelcase */
import bg from './messages_bg.json';
import cs from './messages_cs.json';
import da from './messages_da.json';
import de from './messages_de.json';
import el from './messages_el.json';
import en from './messages_en.json';
import es from './messages_es.json';
import fr from './messages_fr.json';
import hr from './messages_hr.json';
import hu from './messages_hu.json';
import id from './messages_id.json';
import it from './messages_it.json';
import ja from './messages_ja.json';
import ko from './messages_ko.json';
import nl from './messages_nl.json';
import no from './messages_no.json';
import pl from './messages_pl.json';
import pt from './messages_pt.json';
import ro from './messages_ro.json';
import ru from './messages_ru.json';
import sk from './messages_sk.json';
import sv from './messages_sv.json';
import th from './messages_th.json';
import tr from './messages_tr.json';
import uk from './messages_uk.json';
import vi from './messages_vi.json';
import zh_CN from './messages_zh-CN.json';
import zh_HK from './messages_zh-HK.json';
export const comparisonTableHeroMessages = {
    bg,
    cs,
    da,
    de,
    el,
    en,
    es,
    fr,
    hr,
    hu,
    id,
    it,
    ja,
    ko,
    nl,
    no,
    pl,
    pt,
    ro,
    ru,
    sk,
    sv,
    th,
    tr,
    uk,
    vi,
    'zh-HK': zh_HK,
    'zh-CN': zh_CN,
};
